// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"891":"f44745e1","949":"690a029b"}[chunkId] + ".chunk.js";
};